(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .config(TravelExpensesRoute);
    TravelExpensesRoute.$inject = ['$stateProvider'];

    function TravelExpensesRoute ($stateProvider) {
        $stateProvider
            .state('root.travel_expenses', {
                abstract: true,
                url: '/travel_expenses',
                resolve: {
                    expenseTypeList: () => null,
                    paymentTypeList: () => null,
                    sellerList: () => null,
                }
                
            })
            .state('root.travel_expenses.list', {
                url: '/list?expenseId',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/list/list.html',
                        controller: 'TravelExpensesListController',
                        controllerAs: 'TravelExpensesListController'
                    },
                },
                resolve: {
                    expenseTypeList,
                    paymentTypeList
                }
                
            })
            .state('root.travel_expenses.create', {
                url: '/create/:statementId?',
                resolve: {
                    mode: function(){
                        return 'create';
                    },
                    expenseTypeList,
                    paymentTypeList,
                    sellerList: ["SellerService", function(SellerService) {
                        return SellerService.getStaff().then(function(response) {
                            return response.data
                        }).catch(function(error) {
                            return $q.reject(error);
                        });
                    }]
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/form/form.html',
                        controller: 'TravelExpensesFormController',
                        controllerAs: 'TravelExpensesFormCtrl',
                        
                    }
                },
                params: { 'statementId' : null },
            })
            .state('root.travel_expenses.edit', {
                url: '/{expenseId}/edit/:statementId?origin',
                resolve: {
                    mode: function () {
                        return 'edit';
                    },
                    expenseTypeList,
                    paymentTypeList,
                    sellerList: ["SellerService", function(SellerService) {
                        return SellerService.getStaff().then(function(response) {
                            return response.data
                        }).catch(function(error) {
                            return $q.reject(error);
                        });
                    }]
                },
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/form/form.html',
                        controller: 'TravelExpensesFormController',
                        controllerAs: 'TravelExpensesFormCtrl'
                    }
                }
            })
            .state('root.travel_expenses.report', {
                url: '/report',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/report/list.html',
                        controller: 'TravelExpensesReportController',
                        controllerAs: 'travelExpensesReport'
                    }
                },
                resolve: {
                    expenseTypeList,
                    paymentTypeList
                }
            })
            .state('root.travel_expenses.daily_allowance', {
                url: '/dailyallowance',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/dailyallowance/list.html',
                        controller: 'DailyAllowanceController',
                        controllerAs: 'dailyAllowance'
                    }
                }
            })
            .state('root.travel_expenses.statement', {
                url: '/statement',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/uploadStatement/form.html',
                        controller: 'TravelExpensesUploadStatementController',
                        controllerAs: 'travelExpensesUploadStatement'
                    }
                },
                resolve: {
                    expenseTypeList,
                    paymentTypeList
                }
            })
            .state('root.travel_expenses.statement.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/travelexpenses/statements/list.html',
                        controller: 'TravelExpensesStatementListController',
                        controllerAs: 'travelExpensesStatementList'
                    }
                },
                resolve: {
                    expenseTypeList,
                    paymentTypeList
                }
            });
            
    }
    function expenseTypeList() {
        return [{name:'Physical Event',id:'physical_event'},{name:'Virtual Event',id:'virtual_event'},{name:'Other Event',id:'other_event'},{name:'Salary Advance',id:'salary_advance'},{name:'General',id:'general'}];        
    }

    function paymentTypeList() {        
        return [{name:'Business Credit Card',id:'business_credit_card'},{name:'Personal Credit Card',id:'personal_credit_card'},{name:'Personal Cash',id:'personal_cash'},{name:'ATM Business Card',id:'atm'}];
    }

})();